<template>
  <transition :name="settings.routerAnimation" mode="out-in">
    <router-view />
  </transition>
</template>

<script>
import { mapState, mapGetters } from "vuex";

export default {
  name: "SessionLayout",
  computed: {
    ...mapState(["settings"]),
    ...mapGetters({
      userSessions: "session/userSessions"
    })
  },
  data() {
    return {
      t: null
    };
  },
  mounted() {
    // COMMENT THIS FOR REAL IMPLEMENTATION
    this.t = new Date();
    this.t = this.t.setSeconds(this.t.getSeconds() + 10);
    ////////////////////////////////////////////////////

    this.detectViewPort(true);
    window.addEventListener("resize", this.detectViewPortListener);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.detectViewPortListener);
  },
  methods: {
    detectViewPortListener: function() {
      this.detectViewPort(false);
    },
    setViewPort: function(isMobileView = false, isTabletView = false) {
      this.$store.commit("CHANGE_SETTING", {
        setting: "isMobileView",
        value: isMobileView
      });
      this.$store.commit("CHANGE_SETTING", {
        setting: "isTabletView",
        value: isTabletView
      });
    },
    detectViewPort: function(firstLoad = false) {
      const isMobile = this.settings["isMobileView"];
      const isTablet = this.settings["isTabletView"];
      const width = window.innerWidth;
      const state = {
        next: {
          mobile: width < 768,
          tablet: width < 992,
          desktop: !(width < 768) && !(width < 992)
        },
        prev: {
          mobile: isMobile,
          tablet: isTablet,
          desktop: !isMobile && !isTablet
        }
      };
      // desktop
      if (
        state.next.desktop &&
        (state.next.desktop !== state.prev.desktop || firstLoad)
      ) {
        this.setViewPort(false, false);
      }
      // tablet & collapse menu
      if (
        state.next.tablet &&
        !state.next.mobile &&
        (state.next.tablet !== state.prev.tablet || firstLoad)
      ) {
        this.setViewPort(false, true);
        this.$store.commit("CHANGE_SETTING", {
          setting: "isMenuCollapsed",
          value: true
        });
      }
      // mobile
      if (
        state.next.mobile &&
        (state.next.mobile !== state.prev.mobile || firstLoad)
      ) {
        this.setViewPort(true, false);
      }
    }
  }
};
</script>
